import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import partie from '../_mock/partie';
import { fetchUser, getUser, editUser as editUserService } from './userService';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await fetchUser(email, password);
      const data = await response.data;
      const token = await data.token;

      const userData = await getUser(token);
      const user = await userData.data;

      setLoading(false);
      setUser({
        ...user,
      });
      window.localStorage.setItem('token', data.token);
      navigate('dashboard/app');
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const auth = async (token) => {
    setLoading(true);
    try {
      const userData = await getUser(token);
      const user = await userData.data;
      setLoading(false);
      setUser({
        ...user,
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const logout = () => {
    setUser(null);
    window.localStorage.removeItem('token');
  };

  const editUser = (id, editedUser) => {
    return editUserService(id, editedUser);
  };

  return (
    <UserContext.Provider value={{ loading, user, error, editUser, login, logout, auth, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
